import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SearchData, SearchListNewComponent } from '../search-list-new/search-list-new.component';
import { UserService } from '@cots/common/services/user.service';
import { HelpTicket } from '@cots/common/resources/helpTicket';
import { MatSidenav } from '@angular/material/sidenav';
import { UtilityService } from '@cots/common/services/utility.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'help-ticket-queue',
  templateUrl: './help-ticket-queue.component.html',
  styleUrls: ['./help-ticket-queue.component.less']
})
export class HelpTicketQueueComponent implements OnInit {

  constructor(private userSvc: UserService, private dialog: MatDialog) { }

  ngOnInit(): void {
  }
  
  public search({ forAllUsers, searchText, page, sort }: SearchData) {
    return this.userSvc.searchHelpTickets(searchText, sort.active, sort.direction, page.pageIndex, page.pageSize, forAllUsers);
  }

  @ViewChild('sidenav') sidenav: MatSidenav;
  public selectedRecord: HelpTicket;
  onSelect(record: HelpTicket): void {
    // window.open(record.ticketUrl, "_blank");
    if (this.searchListNew.loading) return;
    this.selectedRecord = record;
    this.sidenav.open();
  }

  @ViewChild(SearchListNewComponent) searchListNew: SearchListNewComponent<HelpTicket>; 
  @ViewChild('closeDialogTemplate') closeDialogTemplate: TemplateRef<any>; 
  async markTicketClosed(record: HelpTicket) {
    const dialogRef = await this.dialog.open(this.closeDialogTemplate, {
      disableClose: true,
      minWidth: 500,
      data: {
        reason: ''
      }
    });
    const r: string = await dialogRef.afterClosed().toPromise();
    if (!r) return;
    this.searchListNew.loading = true;
    this.sidenav.close();
    this.selectedRecord = null;
    await this.userSvc.closeHelpTicket(record, r).toPromise();
    this.searchListNew.loading = false;
    this.searchListNew.forceUpdate();
  }

}
